import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AlignHorizontalLeftIcon(props: IconProps) {
    return <Icon {...props} iconKey={"align_horizontal_left"}/>
}
